import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';

// Microsoft Graph Toolkit initialization
import { Providers } from '@microsoft/mgt-element';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';
import '@microsoft/mgt-components';

import App from './App';
import './index.css';

// Configuration Microsoft Graph (SharePoint)
const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID || '8e5d8e7f-a961-497f-b58e-23aebbbacfec';
const TENANT_ID = import.meta.env.VITE_AZURE_TENANT_ID || '7bdc7854-73dd-4e49-8c7d-ad834475782e';

// Initialize Microsoft Graph Toolkit - Fixed for tenant-specific endpoint
if (!Providers.globalProvider) {
  Providers.globalProvider = new Msal2Provider({
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    scopes: [
      'Files.Read.All',        // Lire les fichiers accessibles par l'utilisateur
      'Sites.Read.All',        // Lire les sites accessibles par l'utilisateur
      'User.Read',            // Lire le profil de l'utilisateur connecté
      'offline_access'        // Pour le rafraîchissement des tokens
    ]
  });
}

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <FluentProvider theme={webLightTheme}>
          <App />
        </FluentProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);